<template>
  <div class="map-warp">
    <div class="ol-popup" id="my-popup">
      <div id="popup-content"></div>
    </div>
    <div class="tabs-box">
      <el-radio-group v-model="activeValue">
        <el-radio-button label="drdt">达人地图</el-radio-button>
        <el-radio-button label="dddt">订单地图</el-radio-button>
      </el-radio-group>
      <!-- type="datetimerange" -->
      <div class="date-picker-box">
        <el-date-picker
          v-model="dateValue"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="onChange"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="legend-box">
      <div class="legend-item" v-for="(item, index) in legendList" :key="index">
        <div
          class="legend-item-color"
          :style="{ background: item.color }"
        ></div>
        <div class="legend-item-text">{{ item.count }}</div>
      </div>
    </div>

    <div class="map-box" id="map" ref="map"></div>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";
import { AD_CODE } from "@/utils/constant";
import Map from "ol/Map";
import View from "ol/View";
import { Vector as VectorSource, XYZ as XYZSource } from "ol/source";
import TileLayer from "ol/layer/Tile";
import GeoJSON from "ol/format/GeoJSON";
import VectorLayer from "ol/layer/Vector";
import { Fill, Stroke, Style, Text } from "ol/style";
import { Select } from "ol/interaction";
import { fromLonLat } from "ol/proj";
import Overlay from "ol/Overlay";
import dayjs from "dayjs";
import $ from "jquery";

export default {
  data() {
    // 获取当前日期
    const now = dayjs();
    const startOfMonth = now.startOf("month").format("YYYY-MM-DD HH:mm:ss");
    const endOfMonth = now.endOf("month").format("YYYY-MM-DD HH:mm:ss");
    return {
      dateValue: [startOfMonth, endOfMonth],
      activeValue: "drdt",
      scopeName: "中华人民共和国",
      provinceName: "中华人民共和国",
      parentCenter: [105.8585445, 37.2195855],
      orderId: "",
      mainJS: {},
      zoom: 17,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      url: {
        order: "https://xp.api.51jushifu.com/product/big_screen/scope/order",
        person: "https://xp.api.51jushifu.com/product/big_screen/scope/user",
      },
      norLegendColorList: [
        "#FFFFFF",
        "#A6CFEF",
        "#82BFEE",
        "#60ADEE",
        "#4298EE",
        "#1B84EE",
      ],
      legendList: [
        { count: 0, color: "#FFFFFF" },
        { count: 5, color: "#A6CFEF" },
        { count: 10, color: "#82BFEE" },
        { count: 15, color: "#60ADEE" },
        { count: 20, color: "#4298EE" },
        { count: 25, color: "#1B84EE" },
      ],
    };
  },
  mounted() {
    this.setMap();
  },
  watch: {
    activeValue(value) {
      // console.log(value);
      this.getMapCount(value, this.scopeName);
    },
  },
  methods: {
    onChange(date) {
      this.dateValue = [
        date[0].split(" ")[0] + " 00:00:00",
        date[1].split(" ")[0] + " 23:59:59",
      ];
      this.getMapCount(this.activeValue, this.scopeName);
    },
    // 根据类型获取地图数据
    getMapCount(type, scopeName = "中华人民共和国") {
      let _this = this;
      // console.log(this.provinceName);
      let params = {
        scopeName:
          scopeName === this.provinceName
            ? scopeName
            : this.provinceName + scopeName,
        startTime: this.dateValue[0],
        endTime: this.dateValue[1],
      };
      if (type === "drdt") {
        getAction(this.url.person, params).then((res) => {
          // console.log(res);
          if (res.status === 200 && res.data.code === 1001) {
            const data = res.data.body || [];
            _this.setGeojson(data, scopeName);
          }
        });
      } else if (type === "dddt") {
        getAction(this.url.order, params).then((res) => {
          // console.log(res);
          if (res.status === 200 && res.data.code === 1001) {
            const data = res.data.body || [];
            _this.setGeojson(data, scopeName);
          }
        });
      }
    },
    // 设置geojson
    async setGeojson(data = [], scopeName = "中华人民共和国") {
      // console.log(data);
      const mapList = data.length ? data : [{ count: 25 }];
      // if (data.length) {
      // console.log(this.ceilToNext10(this.getMaxCount(data)));
      const count = this.ceilToNext10(this.getMaxCount(mapList));
      // console.log(this.divideAndIncrement(0, count, 5));
      this.legendList = this.divideAndIncrement(0, count, 5);
      // console.log(this.legendList);
      this.clearGeoJSON();
      let geoJson = {
        type: "FeatureCollection",
        features: [],
      };
      // 根据行政区划名字获取对应geojson
      const response = await fetch(
        `https://cdqdsyfile.oss-cn-shanghai.aliyuncs.com/xingzhengquhua/${scopeName}.json`
      );
      const geosJon = await response.json();
      geoJson.features = geosJon.features.map((i) => {
        if (data.findIndex((j) => j.address === i.properties.name) != -1) {
          i.properties.count = data.find(
            (k) => k.address === i.properties.name
          ).count;
        } else i.properties.count = 0;

        return i;
      });

      this.setSlice(geoJson);
    },
    // 加载地图
    setMap() {
      let _this = this;
      this.mainJS.container = document.getElementById("my-popup");
      this.mainJS.content = document.getElementById("popup-content");
      // 创建一个Overlay，用于显示弹窗
      this.mainJS.overlay = new Overlay({
        element: document.getElementById("my-popup"),
        autoPan: false,
        // autoPanAnimation: {
        //   duration: 250,
        // },
      });
      this.mainJS.baseMap = new TileLayer({
        className: "baseLayerClass",
        source: new XYZSource({
          // projection: mapLayer.exportgGcjMecator(), // 纠偏
          url:
            "//webrd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}",
        }),
      });
      // this.mainJS.center = [103.3858883, 38.5371395];
      this.mainJS.center = [105.8585445, 37.2195855];
      //视图
      this.mainJS.view = new View({
        center: fromLonLat(this.mainJS.center),
        minZoom: 4,
        maxZoom: 9,
        zoom: 4,
        // //1.设置缩放级别为整数
        // constrainResolution: true,
        // //2.关闭无级缩放地图
        // smoothResolutionConstraint: false,
      });
      this.mainJS.map = new Map({
        // layers: [_this.mainJS.baseMap],
        // layers: [],
        target: _this.$refs.map,
        controls: [],
        overlays: [this.mainJS.overlay],
        view: this.mainJS.view,
      });
      this.getMapCount("drdt");
      // 添加行政区划hover效果
      this.addHover();

      this.mainJS.map.on("moveend", function(e) {
        console.log(_this.mainJS.view.getZoom());
        console.log(_this.mainJS.view.getCenter());
      });

      let selectSingleClick = new Select();
      this.mainJS.map.addInteraction(selectSingleClick);
      selectSingleClick.on("select", function(e) {
        let features = e.target.getFeatures().getArray();
        if (features.length > 0) {
          // 单点feature调用回调函数
          if (features[0].values_.data) {
            let data = features[0].values_.data;
            if (data && data.callback) {
              data.callback(e, data.callbackParams, features[0], data.code);
            }
            // 单点是geojson
          } else if (features[0].values_.adcode) {
            console.log(features[0].values_);
            let levelName = features[0].values_.level;
            if (levelName == "city" || levelName == "province") {
              _this.parentCenter = features[0].values_.centroid;
              _this.clearGeoJSON();
              _this.mainJS.map.getView().animate({
                // zoom:
                //   levelName == "city" || levelName == "district"
                //     ? 7
                //     : levelName == "province"
                //     ? 6.5
                //     : 4,
                zoom:
                  levelName == "city" ? 7 : levelName == "province" ? 6.5 : 4,
                center: fromLonLat(features[0].values_.centroid),
                duration: 500,
              });
              _this.scopeName = features[0].values_.name;
              _this.provinceName = AD_CODE.find(
                (i) => i.adcode == features[0].values_.parent.adcode
              ).name;
              console.log(_this.provinceName);
              _this.getMapCount(_this.activeValue, features[0].values_.name);
            }
          }
        }
        selectSingleClick.getFeatures().clear();
        // getFeatures().clear();
      });

      _this.mainJS.map.on("singleclick", function(evt) {
        // console.log(mainJS.geoLayer)
        let temFeature;
        // 是否点击到layer
        _this.mainJS.map.forEachFeatureAtPixel(evt.pixel, function(f) {
          temFeature = f;
          // console.log(temFeature)
        });
        if (!temFeature) {
          // if (_this.mainJS.geoLayer.className_ == "city") {
          if (_this.scopeName !== _this.provinceName) {
            _this.scopeName = _this.provinceName;
            _this.provinceName = "中华人民共和国";
            _this.mainJS.map.getView().animate({
              zoom: _this.scopeName === _this.provinceName ? 4 : 6,
              center: fromLonLat(
                _this.scopeName === _this.provinceName
                  ? _this.mainJS.center
                  : _this.parentCenter
              ),
              duration: 500,
            });

            _this.getMapCount(_this.activeValue, _this.scopeName);
          }
        }

        // console.log(temFeature)
      });
    },
    // 删除所有GeoJSON图层
    clearGeoJSON() {
      if (this.mainJS.geoLayer) {
        this.mainJS.map.removeLayer(this.mainJS.geoLayer);
        this.mainJS.geoLayer = null;
      }
    },

    setSlice(json) {
      let source = new VectorSource({
        features: new GeoJSON().readFeatures(json, {
          dataProjection: "EPSG:4326",
          featureProjection: "EPSG:3857",
        }),
      });
      this.mainJS.geoLayer = new VectorLayer({
        source: source,
        // className: className,
        style: this.createLabelStyle,
      });
      // 添加GeoJSON到map上
      this.mainJS.map.addLayer(this.mainJS.geoLayer);
    },
    //创建默认的样式
    createLabelStyle(feature, hover) {
      // console.log(feature);
      // console.log(hover);
      let titleList;
      let title = "";
      if (feature.get("name")) {
        titleList = feature.get("name").split("");
        title = "";
        titleList.map((i, index) => {
          title += i;
          if (index + 1 == Math.round(titleList.length / 2)) title += "\n";
        });
      }
      let isHover = hover == "hover" ? true : false;
      // 获取count区间颜色
      const norFill =
        this.findColorForValue(feature.get("count"), this.legendList) || "#fff";
      // console.log(norFill);
      //返回一个样式
      return new Style({
        // 切片样式
        fill: new Fill({
          // color: isHover ? "rgba(45,93,199,0.2)" : "rgba(0,0,0,0.05)",
          // color: isHover ? "rgba(45,93,199,0.2)" : "rgba(165, 206, 238, 0.4)",
          color: isHover ? "rgba(45,93,199,0.2)" : norFill,
        }),
        stroke: new Stroke({
          color: isHover ? "#1D79FF" : "rgba(31, 42, 100, 1)",
          // width: isHover ? 3 : 2,
          width: isHover ? 2 : 1,
          // lineDash: isHover ? [] : [4, 8],
        }),
        //文本样式
        text: new Text({
          //对齐方式
          textAlign: "center",
          //文本基线
          textBaseline: "middle",
          //字体样式
          font: "normal 14px 微软雅黑",
          text: title + `：${feature.get("count")}`,
          //填充样式
          fill: new Fill({
            color: isHover ? "#fff" : "rgba(166, 206, 238, 1)",
          }),
          // //笔触
          // stroke: new Stroke({
          //   color: "#ffffff",
          //   width: 3,
          // }),
        }),
        zIndex: 1,
      });
    },
    // 行政区划添加hover效果
    addHover() {
      let _this = this;
      // hover效果
      this.mainJS.map.on("pointermove", function(evt) {
        if (evt.dragging) {
          return;
        }
        if (_this.mainJS.temFeature != null) {
          if (
            _this.mainJS.temFeature.values_.adcode &&
            _this.mainJS.temFeature.values_.geometry
              .getType()
              .includes("Polygon")
          ) {
            _this.mainJS.temFeature.setStyle(
              _this.createLabelStyle(_this.mainJS.temFeature, "")
            );
            _this.mainJS.container.style.display = "none"; // 显示弹窗
          }
          _this.mainJS.temFeature = null;
        }

        _this.mainJS.map.forEachFeatureAtPixel(evt.pixel, function(f) {
          _this.mainJS.temFeature = f;
          if (
            f.values_.adcode &&
            f.values_.geometry.getType().includes("Polygon")
          ) {
            _this.mainJS.temFeature.setStyle(
              _this.createLabelStyle(f, "hover")
            );

            // 当鼠标悬停在要素上时
            const coordinates = fromLonLat(
              _this.mainJS.temFeature.values_.centroid
            );

            // console.log(_this.mainJS.temFeature);
            _this.mainJS.overlay.setPosition(coordinates); // 设置弹窗位置
            _this.mainJS.content.innerHTML = `${_this.mainJS.temFeature.values_.name}:${_this.mainJS.temFeature.values_.count}`; // 设置弹窗内容
            _this.mainJS.container.style.display = "block"; // 显示弹窗
          }

          return true;
        });
      });
    },
    getMaxCount(items) {
      return items.reduce(
        (max, item) => (item.count > max ? item.count : max),
        items[0].count
      );
    },
    ceilToNext10(num) {
      return Math.ceil(num / 10) * 10;
    },
    divideAndIncrement(start, end, parts) {
      let _this = this;
      // 计算每一份的大小
      const increment = (end - start) / parts;

      // 创建一个数组来存储结果
      const result = [];

      // 生成并填充结果数组
      for (let i = 0; i <= parts; i++) {
        result.push({
          count: parseFloat((start + increment * i).toFixed(2)),
          color: _this.norLegendColorList[i],
        }); // 保留两位小数
      }

      return result;
    },
    findColorForValue(value, dataArray) {
      // 从大到小排序数组，确保顺序
      const sortedData = dataArray.sort((a, b) => b.count - a.count);

      // 找到第一个“count”值小于等于给定值的颜色
      for (const item of sortedData) {
        if (value >= item.count) {
          return item.color; // 返回匹配的颜色
        }
      }
      return null; // 如果没有找到匹配项，则返回null
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .baseLayerClass {
  filter: blur(0px) grayscale(100%) sepia(66%) invert(90%) opacity(100%)
    saturate(100%) hue-rotate(0deg);
}
/deep/#my-popup {
  background: #000000;
  border-radius: 2px;
  padding: 7px 10px;
  color: #fff;
}
.map-warp {
  // width: 898px;
  // height: 1088px;
  overflow: hidden;
  // position: relative;
  /deep/.legend-box {
    position: absolute;
    z-index: 1;
    left: 590px;
    top: 80vh;
    .legend-item {
      color: #ffffff;
      display: flex;
      align-items: center;
      height: 20px;
      margin-bottom: 10px;
    }
    .legend-item-color {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      border: 1px solid #ffffff;
      margin-right: 8px;
    }
    .legend-item-text {
      font-size: 12px;
    }
  }
  /deep/ .tabs-box {
    position: absolute;
    padding: 3px;
    width: 332px;
    top: 180px;
    left: calc(50% - 166px);
    z-index: 1;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    .el-radio-button {
      width: 163px;
      text-align: center;
      height: 40px;
      border-radius: 4px;
      .el-radio-button__inner {
        box-shadow: unset;
        border: 0;
        background: transparent;
        color: #fff;
        font-size: 16px;
        &:hover {
          color: #fff;
        }
      }
      &.is-active {
        background: rgba(255, 255, 255, 0.1);
      }
    }
    .date-picker-box {
      position: absolute;
      z-index: 1;
      top: 70px;
      left: 240px;
      .el-range-separator {
        color: #c0c4cc;
        line-height: 35px;
      }
      .el-input__icon {
        line-height: 35px;
      }
      .el-date-editor {
        background: rgba(255, 255, 255, 0.1);
        border: 0;
      }
      .el-range-input {
        color: #fff;
        background: transparent;
        border: 0 !important;
      }
    }
  }
}
#map {
  width: 900px;
  height: 75vh;
  position: fixed;
  left: calc(50% - 450px);
  top: 25vh;

  // width: 898px;
  // height: 1088px;
}
</style>
